import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"

export default {
    data() {
        return {
            orgId: '',
            formInline: {
                numberType: '',
                number: ''
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('VehicleAnalysis.carId')
            }, {
                value: '2',
                label: this.$t('VehicleAnalysis.plateNum')
            },
            {
                value: '3',
                label: this.$t('VehicleAnalysis.manufactureNum')
            },
            {
                value: '4',
                label: this.$t('VehicleAnalysis.customNum')
            }],
            height: '500',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true, 
                serialNumber: true,
            },
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1, 
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    methods: {
        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
                numberType: this.formInline.numberType,
                number: this.formInline.number
            };
            this.$store.dispatch('VehicleAnalysis/GET_QUERYCARDAYWORKTIME', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.label.map(item => {
                            item.align = 'center'
                            item.width = '120'
                        })
                        this.columns = res.data.data.label
                        this.list = res.data.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline.numberType = ''
            this.formInline.number = ''
            this.getMonthOrderList()
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportCarDayWorkTime?orgId=${this.orgId}&selectType=${0}&numberType=${this.formInline.numberType}&number=${this.formInline.number}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCarDayWorkTime?orgId=${this.orgId}&selectType=${0}&numberType=${this.formInline.numberType}&number=${this.formInline.number}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMonthOrderList()
        },
    }
}
